import React from "react";

import { AHSeparator, Box } from "arkh";

export function DailyHeader(props: { numberOfFilteredItems: number }) {
  return (
    <Box
      color="surface-primary"
      cornerRadiusTopLeft="large"
      cornerRadiusTopRight="large"
      cornerRadiusBottomLeft={
        props.numberOfFilteredItems === 0 ? "large" : "none"
      }
      cornerRadiusBottomRight={
        props.numberOfFilteredItems === 0 ? "large" : "none"
      }
      borderColor="border-primary"
    >
      {props.numberOfFilteredItems > 0 ? <AHSeparator /> : null}
    </Box>
  );
}
